export default [
  {
    path: '/mall/commodity',
    name: 'commodity',
    component: () => import('./commodity/index.vue')
  }, {
    path: '/mall/discounts',
    name: 'discounts',
    component: () => import('./discounts/index.vue')
  }
];


// WEBPACK FOOTER //
// ./src/views/mall/index.route.js